import { render, staticRenderFns } from "./AddStockTakeProductionModal.vue?vue&type=template&id=65c7448c&"
import script from "./AddStockTakeProductionModal.vue?vue&type=script&lang=js&"
export * from "./AddStockTakeProductionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports